import * as React from 'react';
import { GoogleLogin, GoogleOAuthProvider } from '@react-oauth/google';
import { useHistory } from 'react-router-dom';
import { getLogger } from '../../services/logger.service';

import { Provider } from '../../services/connection/auth.connection';
import environmentService from '../../services/environment.service';
import authStore from '../../stores/auth.store';

const log = getLogger('GoogleAuth');

interface Props {
  context: 'signin' | 'signup';
}

const GoogleAuth = ({ context }: Props) => {
  const history = useHistory();
  const clientId = environmentService.isProduction() ?
    '764318139753-hvsiec8a2mn11h69ppls91a6bk3cjelq.apps.googleusercontent.com' :
    '764318139753-l8r130qsk1qnte9e16lqrihtdfg3njur.apps.googleusercontent.com';

  return (
    <GoogleOAuthProvider clientId={clientId}>
      <GoogleLogin
        text={context === 'signup' ? 'signup_with' : 'signin_with'}
        width={346} // the auth pages' .container width, so the button spans it
        onSuccess={async response => {
          if (!response.credential) {
            log.e('google login returned no credential');
            return;
          }
          await authStore.token(response.credential, Provider.GOOGLE);
          history.push('/');
        }}
        onError={() => log.e('there was an error with google login')}
      />
    </GoogleOAuthProvider>
  );
};

export default GoogleAuth;
